export const APPLICATION_POLL_STATUS_INTERVAL = 10_000;
export const APPLICATION_POLL_TIMEOUT = 90_000;
